import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import AdCaller from 'helpers/ads/adCaller';
import WithDelay from 'helpers/hoc/WithDelay';
import Cookie from 'utils/cookies';
import makeRequest from 'utils/makeRequest';
import { UNIFIED_FEED_DOMAIN } from '../../../constants';
import s from '../Footer/Footer.scss';
import ResourceLinks from '../../common/ResourceLinks';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showunderToneAd: false,
    };
  }
  componentDidMount() {
    window.times = window.times || {};
    window.times.cookie = window.times.cookie || {};
    window.times.cookie.set = window.times.cookie.set || Cookie.set;

    if (
      typeof window !== 'undefined' &&
      window.geoinfo &&
      (typeof window.geoinfo.CountryCode === 'string' ||
        typeof window.geoinfo.region_code === 'string')
    ) {
      if (
        window.geoinfo.CountryCode === 'US' &&
        window.geoinfo.region_code === 'CA'
      ) {
        this.addAdditionalLinks();
      }
      if (
        window.geoinfo.CountryCode === 'US' ||
        window.geoinfo.CountryCode === 'CA'
      ) {
        this.setState({
          showunderToneAd: true,
        });
      }
    }

    const { footerData } = this.props;
    if (
      footerData &&
      footerData.lastSectionItems &&
      Array.isArray(footerData.lastSectionItems.items)
    ) {
      this.initIntervalUpdation();
    }
  }

  initIntervalUpdation = () => {
    setInterval(() => {
      const url = `${UNIFIED_FEED_DOMAIN}/wufs/top-news/fetch/latest/articles/toi`;
      makeRequest.get(url, {}).then(response => {
        if (response && Array.isArray(response.data)) {
          this.setState({
            lastSectionItems: {
              label: 'Latest News',
              items: response.data.slice(0, 18),
            },
          });
        }
      });
    }, 600000);
  };

  addAdditionalLinks = () => {
    // if (
    //   this.props.footerData?.siteLinks?.items &&
    //   Array.isArray(this.props.footerData.siteLinks.items)
    // )
    //   this.props.footerData.siteLinks.items.push({
    //     wu: 'https://timesofindia.indiatimes.com/donotsell.cms',
    //     hl: 'Do Not Sell Data',
    //   });
  };

  renderSection = (secData, wholeWidth = false) => {
    const columnData = [];
    const secLabelForGA = secData.label ? secData.label : 'TOI';
    if (secData && secData.items && secData.items.length > 0) {
      secData.items.forEach(col => {
        columnData.push(
          <Link
            to={col.eulink && this.props.isPrivateUser ? col.eulink : col.wu}
            key={col.wu}
            className={col.cls}
            data-newga={`Footer_Actions#${secLabelForGA}-${col.hl}`}
            title={col.hl}
          >
            {col.hl}
          </Link>,
        );
      });
      return (
        <div
          className={`${s.section} ${wholeWidth ? s.whole_width : ''}`}
          key={secData.label}
        >
          {secData.label ? (
            <h2 className={s.section_heading}>{secData.label}</h2>
          ) : null}
          <div className={s.section_items}>{columnData}</div>
        </div>
      );
    }
    return null;
  };

  renderIcons = icons => {
    const iconData = [];
    if (icons && icons.items && icons.items.length > 0) {
      icons.items.forEach(icon => {
        iconData.push(
          <Link
            className={`${s.footer_icon} ${icon.type}`}
            to={icon.wu}
            //title={icon.hl}
            data-newga={`Footer_Actions#SocialMedia-${icon.hl}`}
            key={icon.hl}
          />,
        );
      });
      return (
        <div className={s.social_wrapper}>
          {icons.label ? (
            <div className="social_footer_heading">{icons.label}</div>
          ) : null}
          <div className={s.social_icons}>{iconData}</div>
        </div>
      );
    }
    return null;
  };
  // componentDidMount() {
  //   this.props.loadFooterData();
  // }
  render() {
    const { footerData, isFeatureShow } = this.props;
    if (footerData) {
      const sections = [];
      if (footerData.sections && footerData.sections.length > 0) {
        footerData.sections.forEach(sec => {
          // sections.push(this.renderSection(sec));
          sections.push(
            <div className={s.section_item}>
              <ResourceLinks sectionData={sec} />
            </div>,
          );
        });
      }

      return (
        <div
          data-translate-id="cw"
          className={`${s.footer_container} ${
            s.etimes_footer_wrapper
          } footer_wrapper  contentwrapper`}
        >
          <div className={s.footerlogobox}>
            <div className={s.footerlogoboxIn}>
              {footerData.logo ? (
                <Link
                  className={s.toilogo}
                  to={footerData.logo.link}
                  data-newga="Footer_Actions#TOI-logo"
                >
                  <Image
                    src="https://static.toiimg.com/photo/104184222.cms"
                    alt="logo"
                    lazyload
                  />
                </Link>
              ) : null}
            </div>
          </div>
          <div className="contentwrapper">
            {/* <div className={`${s.footer_left_col}`}> */}
            {footerData.otherTimesSite
              ? this.renderSection(footerData.otherTimesSite)
              : null}
            {/* </div> */}
            {/* <div className={`${s.footer_right_col}`}> */}
            {isFeatureShow && Array.isArray(sections) && sections?.length > 2
              ? sections?.slice(2, 5)
              : sections}
            {/* </div> */}
            {(footerData.lastSectionItems &&
              Array.isArray(footerData.lastSectionItems.items)) ||
            (this.state.lastSectionItems &&
              Array.isArray(this.state.lastSectionItems.items)) ? (
              <ResourceLinks
                sectionData={
                  this.state.lastSectionItems || footerData.lastSectionItems
                }
                sectionClass="Threecolumn"
              />
            ) : null}

            {/* <div className={s.otgrpsite}> */}
            {/* <h4>Other Group Sites - </h4>
              <ul>
                <li>
                  <a
                    target="_blank"
                    href="https://www.idiva.com/"
                    rel="nofollow noreferrer"
                  >
                    Idiva
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://economictimes.indiatimes.com/panache"
                    rel="nofollow noreferrer"
                  >
                    ET Panache
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.mensxp.com/"
                    rel="nofollow noreferrer"
                  >
                    Mensxp
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.femina.in/"
                    rel="nofollow noreferrer"
                  >
                    Femina
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://www.indiatimes.com/"
                    rel="nofollow noreferrer"
                  >
                    Indiatimes
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://photogallery.indiatimes.com/"
                    rel="nofollow noreferrer"
                  >
                    Photo Gallery
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://beautypageants.indiatimes.com/"
                    rel="nofollow noreferrer"
                  >
                    Beauty Pageants
                  </a>
                </li>
              </ul>
            </div> */}

            {footerData.disclaimer ? (
              <div className={s.disclaimer}>
                <div>{footerData.disclaimer}</div>
                {footerData.social ? this.renderIcons(footerData.social) : null}
              </div>
            ) : null}
          </div>
          {footerData.underTone &&
            this.state.showunderToneAd && (
              <WithDelay delay={3000}>
                <AdCaller
                  immediateLoad
                  data={footerData.underTone}
                  deviceType="all"
                />
              </WithDelay>
            )}
        </div>
      );
    }

    return null;
  }
}

Footer.propTypes = {
  footerData: PropTypes.shape({}).isRequired,
  isPrivateUser: PropTypes.bool.isRequired,
};

export default Footer;
